import { render } from "./LandingSection.vue?vue&type=template&id=b169881c&scoped=true&ts=true"
import script from "./LandingSection.vue?vue&type=script&lang=ts"
export * from "./LandingSection.vue?vue&type=script&lang=ts"

import "./LandingSection.vue?vue&type=style&index=0&id=b169881c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b169881c"]])

export default __exports__